
export const hostapi = process.env.NODE_ENV === 'production' ? 'https://wxapp.moveclub.cn/' : 'https://wxapp.moveclub.cn/';

export const API_STATUS  = {SUCCESS:200}

////http://bt.jd.com/v3/mobile/zoneAuth?source=97&backURL=&failBackURL=
export const backurl  =  'https://wxappview.moveclub.cn/jdauth/succes&failBackURL=https://wxappview.moveclub.cn/jdauth/fail';
// export const backurl ='http://127.0.0.1:8080/jdauth/succes&failBackURL=http://127.0.0.1:8080/jdauth/fail';





// WEBPACK FOOTER //
// ./src/util/params.js